import React from 'react';
import FilterCarModel from '../../../components/organism/FilterMenu/CarModel';
import FilterSpecialOffer from '../../../components/organism/FilterMenu/SpecialOffer';
import { IFilterOptions } from '../../../interface/accessories.interface';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';

export default function generateFilterServicePackages(
  carModel: IFilterOptions,
  specialOffer: IFilterOptions,
  typeID: string,
  setTriggerFilter?,
  impressionData?: {
    title?: string;
    carModels: string[];
    breadcrumbItems: IBreadcrumbs[];
    customerNo?: string;
    carCategory?: string;
    filterValue?: {
      search?: string;
      special_offer?: string;
      car_model?: string;
      order_by?: string;
    };
    sectionName: string;
  },
  feature?: string
) {
  const dataFilter = [
    {
      title: 'Penawaran Khusus',
      content: specialOffer?.values?.length ? (
        <FilterSpecialOffer
          offerList={specialOffer}
          typeID={typeID}
          setTrigger={setTriggerFilter}
          impressionData={impressionData}
          feature={feature}
        />
      ) : null,
    },
    {
      title: carModel?.name || 'Model Mobil',
      content: carModel ? (
        <FilterCarModel
          carModelList={carModel.values}
          typeID={typeID}
          setTrigger={setTriggerFilter}
          impressionData={impressionData}
          feature={feature}
        />
      ) : null,
    },
  ];

  return dataFilter;
}
